/* istanbul ignore file - better tested visually */

import { classNames } from '@partful/shared/lib/classNames';
import { Typography } from '@partful/shared/ui/Typography';
import { ComponentProps, forwardRef } from 'react';
import styles from './Badge.module.scss';

export type BadgeProps = {
  variant?: 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'default';
} & ComponentProps<'div'>;

export const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ variant = 'default', className, children, ...rest }, ref) => (
    <Typography
      as="div"
      appearance="label"
      className={classNames(styles.badge, styles[variant], className)}
      {...rest}
      ref={ref}
    >
      {children}
    </Typography>
  )
);
